export default function ModelName(props){
  const company = props.company ?? "";
  const modelName = props.modelName ?? "";
  const modelDesc = props.modelDesc ?? "";
  const modelInfo = props.modelInfo ?? [];

  return (
    <div className="w-[320px] lg:w-[700px]">
      <p className="mt-4 text-xs text-hover lg:test-sm lg:mt-0">{company}</p>
      <p className="text-xl lg:text-2xl w-[320px] lg:w-[700px]">{modelName}</p>
      <p className="mb-2 text-base">{modelDesc}</p>
      {modelInfo.map((info, index)=> (
        <div key={index}  className="flex flex-row mb-1">
          <p className="mr-1 text-xs text-gray-500 lg:text-sm">-</p>
          <p className="text-xs text-gray-500 lg:text-sm">{info}</p>
        </div>
      )
      )}
    </div>
  );
}